<content-with-tabs-v2
  [tabLinks]="tabLinks"
  [bottomBar]="showFooter$ | async"
  [customActivePaths]="true"
  [componentTemplate]="selectedComponent"
>
  <sidenav-title
    [titleTemplate]="titleTemplate"
    [customActionsTemplate]="customActionsTemplate"
    [isEditEnabled]="(isPreview$ | async) && isContactDetails && contactData"
    [isRemoveEnabled]="(isPreview$ | async) && isContactDetails && contactData && canRemoveContact"
    [closeFunc]="(showFooter$ | async) ? cancel.bind(this) : null"
    [customClass]="'strict-height'"
    (removeClick)="removeContact()"
    (editClick)="editContact()"
  />

  @if (showFooter$ | async) {
    <div class="sticky-footer" footer>
      <ng-container *ngFor="let button of footerButtons">
        <app-button
          (onClick)="button.action()"
          [loading]="loading && button.loading"
          [disabled]="loading"
          [config]="{
            size: ButtonSize.LARGE,
            type: button.type,
            text: button.text | translate
          }"
        />
      </ng-container>
    </div>
  }
</content-with-tabs-v2>

<ng-template #customActionsTemplate>
  <div
    class="sidenav-title-edit sidenav-copy-contact align-content-center justify-content-center"
    (click)="copyContactToClipboard()"
  >
    <img src="/assets/img/ic-copy_to_clipboard_blue.svg" alt="Copy contact data" />
  </div>
</ng-template>

<ng-template #titleTemplate>
  <div class="mr-2">
    @if (contactData$ | async; as contact) {
      <h2 class="contact-title">
        <span class="contact-title__name" [matTooltip]="contact | contactName" matTooltipPosition="below">
          {{ contact | contactName }}
        </span>
        <span class="font-weight-light">{{ 'Contacts.V2.' + contact.type | translate }}</span>
      </h2>
    } @else {
      <h2>{{ 'Contacts.V2.newContactTitle' | translate }}</h2>
    }
  </div>
</ng-template>
